export default __webpack_public_path__ + "static/media/Sharp Ram.f2da234f.png";